__webpack_require__.p = "/oyola-ai/";